import Echo from "laravel-echo"
import { fabric } from "fabric";
import Resumable from 'resumablejs';
import axios from 'axios';
import Sortable from 'sortablejs';
import L from 'leaflet';
import './utils/canvasHistory';

window.Pusher = require('pusher-js');
window.Resumable = Resumable;
window.L = L;

const resolvedCsrfToken =
    document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    || document.querySelector('input[name="_token"]')?.value
    || '';

window.csrfToken = resolvedCsrfToken;
axios.defaults.headers.common['X-CSRF-TOKEN'] = resolvedCsrfToken;

let wsHost, wsPath, forceTLS;
if (window.location.protocol === 'https:') {
    wsHost = window.location.hostname;
    wsPath = '/ws';
    forceTLS = true;

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: 'MY-Key-sd-Push_Id_222',
        cluster: "ap2",
        wsHost: wsHost,
        wsPath: wsPath,
        forceTLS: forceTLS,
        disableStats: true,
        csrfToken:csrfToken,
        authEndpoint: window.Laravel.appUrl + 'broadcasting/auth',
        namespace: '',
        enabledTransports: ['ws', 'wss'],
    });
} else {
    wsHost = window.location.hostname;
    wsPath = '';
    forceTLS = false;

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: 'MY-Key-sd-Push_Id_222',
        cluster: "ap2",
        wsHost: wsHost,
        wsPort: window.Laravel.wsPort,
        forceTLS: forceTLS,
        disableStats: true,
        csrfToken:csrfToken,
        authEndpoint: window.Laravel.appUrl + 'broadcasting/auth',
        namespace: '',
        enabledTransports: ['ws', 'wss'],
    });
}


window.fabric = fabric;
window.Sortable = Sortable;
